import { Component, EventEmitter, Output } from '@angular/core'
import { Daterange } from '@northfork/ng-basics'
import { subDays } from 'date-fns'

@Component({
  selector: 'corporate-actions-advanced-options',
  templateUrl: './corporate-actions-advanced-options.component.html',
  styleUrls: ['./corporate-actions-advanced-options.component.scss'],
})
export class CorporateActionsAdvancedOptionsComponent {
  @Output() dateRangeSelected = new EventEmitter<{
    minEffectiveDateValue: string
    maxEffectiveDateValue: string | null | undefined
  }>()

  minEffectiveDate = subDays(new Date(), 30).toISOString().split('T')[0]
  maxEffectiveDate: string | null | undefined
  maxDate = '2100-12-31'

  dateRange: Daterange = {
    beginDate: this.minEffectiveDate,
    endDate: null,
  }

  applyDateRange(nfDateRange: Daterange) {
    this.maxEffectiveDate = nfDateRange.endDate
    this.minEffectiveDate = nfDateRange.beginDate ?? this.minEffectiveDate
    this.dateRangeSelected.emit({
      minEffectiveDateValue: this.minEffectiveDate,
      maxEffectiveDateValue: this.maxEffectiveDate,
    })
  }
}
